<template>
  <slot v-if="false" />
  <template v-else>
    {{ lastPage.data.paginator.total }}
  </template>
</template>

<script setup>
import { computed } from 'vue';
import useProductListQuery from '../composables/useProductListQuery';

const props = defineProps({
  productList: {
    type: Object,
    default: null,
  },
  paginator: {
    type: Object,
    required: true,
  },
  filters: {
    type: Array,
    required: true,
  },
  sorts: {
    type: Array,
    required: true,
  },
});

const { data } = useProductListQuery(props.paginator, props.filters, props.sorts, props.productList);

const lastPage = computed(() => data.value?.pages[data.value.pages.length - 1]);

</script>
